import { PAST_PERFORMANCE_TRANSITION_CALCULATOR_RESULTS } from '../../../actions/pastPerformanceCalculator/pastPerformanceCalculator';
import { pastPerfomanceCalculatorFormTracking } from './calculator';

export const pastPerfomanceCalculatorTracking = (store, next, action) => {
    if (action.type === PAST_PERFORMANCE_TRANSITION_CALCULATOR_RESULTS) {
        return pastPerfomanceCalculatorFormTracking(store, next, action);
    }
};

